import { metadata } from './support'

export const putProjectMembers = (projectId, members, versionId) =>
  metadata.putJson(
    `metadata/project/${projectId}/members`,
    { members, rowVersion: versionId },
    3
  )
